var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "design-comment" } }, [
    _c("div", { staticClass: "title-area clearfix" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("tenantProjects.submission.comment.cpReview")) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "records" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.displayUnderReviewText,
                expression: "displayUnderReviewText",
              },
            ],
            staticClass: "update-history__text",
          },
          [_vm._v("\n        " + _vm._s(_vm.underReviewText) + "\n      ")]
        ),
        _vm._v(" "),
        _c("div", [
          _vm.isStarted
            ? _c("i", { staticClass: "font-gray" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.reviewStartTime) + "\n        "
                ),
              ])
            : _vm._e(),
        ]),
      ]),
    ]),
    _vm._v(" "),
    !_vm.isStarted
      ? _c("div", [
          _vm.canComment && _vm.startReview
            ? _c("div", { staticClass: "start-btn-wrapper" }, [
                _c(
                  "button",
                  {
                    staticClass: "start-btn btn--darkblue",
                    on: { click: _vm.startDesignReview },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.deep(_vm.activeSubmission, "techComment")
                            ? _vm.$t("action.comment")
                            : _vm.$t("action.startReview")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ])
            : _c("div", [
                _c("p", { staticClass: "design-comment-not-started" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(
                          "tenantProjects.submission.comment.designNotStarted"
                        )
                      ) +
                      ".\n      "
                  ),
                ]),
              ]),
        ])
      : _c("div", [
          !_vm.isPic && !_vm.isSubmitted && !_vm.designComment.description
            ? _c("div", { staticClass: "under-review-hint__text" }, [
                _vm._v("\n      " + _vm._s(_vm.underReviewText) + "\n    "),
              ])
            : _c(
                "div",
                { staticClass: "design-comment-action-container" },
                [
                  _vm.isSubmitted
                    ? _c(
                        "div",
                        { staticClass: "design-comment-action" },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("status.name")) + ":"),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.actionHistory, function (rec) {
                            return _c(
                              "div",
                              {
                                key: rec.id,
                                staticClass: "design-comment-history clearfix",
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.actionTexts[rec.comment])),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "update-history__text" },
                                  [
                                    _vm._v(
                                      _vm._s(rec.user.displayName) +
                                        " " +
                                        _vm._s(_vm.$t("on")) +
                                        " " +
                                        _vm._s(
                                          _vm.dateUtil.format(
                                            rec.updatedAt,
                                            "DD MMM YY HH:mm"
                                          )
                                        )
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isPic && _vm.canComment
                    ? _c("div", { staticClass: "design-comment__textarea" }, [
                        _c("textarea", {
                          directives: [
                            { name: "autosize", rawName: "v-autosize" },
                            { name: "hkldinput", rawName: "v-hkldinput" },
                          ],
                          staticClass: "comment-text autosize",
                          attrs: { type: "text" },
                          domProps: { value: _vm.designComment.description },
                          on: {
                            change: function (event) {
                              return _vm.updateDescription(event.target.value)
                            },
                          },
                        }),
                      ])
                    : _vm.isPic ||
                      _vm.isSubmitted ||
                      _vm.designComment.description
                    ? [
                        _vm.isSubmitted ? _c("hr") : _vm._e(),
                        _vm._v(" "),
                        _c("p", { staticClass: "design-comment-text" }, [
                          _c("pre", [
                            _vm._v(
                              _vm._s(_vm.designComment.description || "--")
                            ),
                          ]),
                        ]),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "design-comment-history" },
                    _vm._l(_vm.commentHistory, function (rec) {
                      return _c(
                        "div",
                        { key: rec.id, staticClass: "clearfix" },
                        [
                          _c("div", { staticClass: "update-history__text" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("workPermit.reviewedBy", [
                                    rec.user.displayName,
                                    _vm.dateUtil.format(
                                      rec.updatedAt,
                                      "DD MMM YY HH:mm"
                                    ),
                                  ])
                                ) +
                                "\n          "
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ],
                2
              ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }